import { Injectable } from '@angular/core';

import {httpOptions} from '../../configurations/configuration';
import { HttpClient, HttpHeaders,HttpErrorResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReviewService {

  constructor(private http: HttpClient) { }

  updateReview(postObj:any) : Observable<any> {
      return this.http.post(environment.apiURL + environment.adminApiUrl + environment.updateReviewUrl, postObj,httpOptions);
  }
        
  insertReview(postObj:any) : Observable<any> {
      return this.http.post(environment.apiURL + environment.adminApiUrl + environment.insertReviewUrl, postObj,httpOptions);
  }    
  
  getReview( id: any) : Observable<any> {
      
      if(id){

      }
      else {
          id = 1;
      }

      return this.http.get(environment.apiURL + environment.adminApiUrl + environment.getReviewUrl+"/" + id);
  }

  getAllReview(filterObj,start,limit){

    filterObj.languageId = localStorage.getItem('languageId');

      let urlGetAllReview = environment.apiURL + environment.adminApiUrl + environment.getReviewUrl +'?filter='+encodeURIComponent(JSON.stringify(filterObj))+'&start='+start+'&limit='+limit;
      return this.http.get<any>(urlGetAllReview)
  }

  deleteReview(postObj:any) : Observable<any> {
      return this.http.post(environment.apiURL + environment.adminApiUrl + environment.deleteReviewUrl, postObj,httpOptions);
  }
}
